export default "__VITE_ASSET__33e01f4b__"